import {
  GetPredictionsByUUIDResponse,
  GetPredictionsItemResponse,
  GetPredictionsRankingResponse,
  GetPredictionsResponse,
  GetPredictionsResultResponse,
  PostPredictionsResponse,
  PutPredictionsResponse,
} from '@/services/response/predictions';
import { Predictions, PredictionsRankingItem, PredictionsResult } from '@/model/predictions';

export class PredictionsConverter {
  static toDomainFromPredictionItemResponse(response: GetPredictionsItemResponse): Predictions {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      identifier: response.identifier,
      status: response.status,
      interactivity: response.interactivity,
      option_a_name: response.option_a_name,
      option_a_result: response.option_a_result ?? '',
      option_a_image_url: response.option_a_image_url ?? '',
      option_b_name: response.option_b_name,
      option_b_result: response.option_b_result ?? '',
      option_b_image_url: response.option_b_image_url ?? '',
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      closing_date: response.closing_date,
      total_participants: response.total_participants,
      total_comments: response.total_comments,
      total_hits: response.total_hits,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPredictionsPaginatedResponse(response: GetPredictionsResponse): Predictions[] {
    return response.data.map(PredictionsConverter.toDomainFromPredictionItemResponse);
  }

  static toDomainFromGetPredictionByUUIDResponse(response: GetPredictionsByUUIDResponse): Predictions {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      identifier: response.identifier,
      status: response.status,
      interactivity: response.interactivity,
      option_a_name: response.option_a_name,
      option_a_result: response.option_a_result ?? '',
      option_a_image_url: response.option_a_image_url ?? '',
      option_b_name: response.option_b_name,
      option_b_result: response.option_b_result ?? '',
      option_b_image_url: response.option_b_image_url ?? '',
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      closing_date: response.closing_date,
      total_participants: response.total_participants,
      total_comments: response.total_comments,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      total_hits: response.total_hits,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromGetPredictionsResultResponse(response: GetPredictionsResultResponse): PredictionsResult {
    return {
      uuid: response.uuid,
      identifier: response.identifier,
      title: response.title,
      description: response.description,
      start_date: response.start_date,
      closing_date: response.closing_date,
      closed_at: response.closed_at,
      option_a_name: response.option_a_name,
      option_a_result: response.option_a_result,
      option_a_image_url: response.option_a_image_url,
      option_b_name: response.option_b_name,
      option_b_result: response.option_b_result,
      option_b_image_url: response.option_b_image_url,
      total_participants: response.total_participants,
      total_hits: response.total_hits,
      hit_percentage: response.hit_percentage,
      breakdown: response.breakdown,
    };
  }

  static toDomainFromPredictionsRankingResponse(response: GetPredictionsRankingResponse): PredictionsRankingItem[] {
    return response.map(item => ({
      rank: Number(item.rank),
      account_uuid: item.account_uuid,
      account_avatar_url: item.account_avatar_url,
      account_display_name: item.account_display_name,
      total_points: Number(item.total_points),
      total_hits: Number(item.total_hits),
      total_predictions: Number(item.total_predictions),
      hit_percentage: Number(item.hit_percentage),
      last_vote_at: item.last_vote_at,
    }));
  }

  static toDomainFromPostPredictionsResponse(response: PostPredictionsResponse): Predictions {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      identifier: response.identifier,
      status: response.status,
      interactivity: response.interactivity,
      option_a_name: response.option_a_name,
      option_a_result: response.option_a_result ?? '',
      option_a_image_url: response.option_a_image_url ?? '',
      option_b_name: response.option_b_name,
      option_b_result: response.option_b_result ?? '',
      option_b_image_url: response.option_b_image_url ?? '',
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      closing_date: response.closing_date,
      total_participants: response.total_participants,
      total_comments: response.total_comments,
      total_hits: response.total_hits,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutPredictionsResponse(response: PutPredictionsResponse): Predictions {
    return {
      uuid: response.uuid,
      title: response.title,
      description: response.description,
      identifier: response.identifier,
      status: response.status,
      interactivity: response.interactivity,
      option_a_name: response.option_a_name,
      option_a_result: response.option_a_result ?? '',
      option_a_image_url: response.option_a_image_url ?? '',
      option_b_name: response.option_b_name,
      option_b_result: response.option_b_result ?? '',
      option_b_image_url: response.option_b_image_url ?? '',
      disable_comments: response.disable_comments,
      enable_home: response.enable_home,
      closing_date: response.closing_date,
      total_participants: response.total_participants,
      total_comments: response.total_comments,
      total_hits: response.total_hits,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }
}
